export default "__VITE_ASSET__fa14d84c__"